import { render, staticRenderFns } from "./IClassroomMultiPicker.vue?vue&type=template&id=6407d8bc&"
import script from "./IClassroomMultiPicker.vue?vue&type=script&lang=js&"
export * from "./IClassroomMultiPicker.vue?vue&type=script&lang=js&"
import style0 from "./IClassroomMultiPicker.vue?vue&type=style&index=0&id=6407d8bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports